// src/authConfig.js
// Pre-configured for The IMA Group tenant
// App Registration: "Phishing Incident Response" — 3eea135c-b0e1-4693-8f50-cd41e6ea501b
// Production URL: https://kind-river-0c5db500f.7.azurestaticapps.net

export const msalConfig = {
  auth: {
    clientId: "3eea135c-b0e1-4693-8f50-cd41e6ea501b",
    authority: "https://login.microsoftonline.com/deb5b3ad-aea3-4155-9bdc-a24b07cb7dd4",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === "development") console.log(message);
      },
    },
  },
};

// Scopes requested at login — covers all modules
export const loginRequest = {
  scopes: [
    "User.Read",
    "Mail.ReadWrite",
    "Mail.Send",
    "MailboxSettings.ReadWrite",
    "Sites.ReadWrite.All",
    "AuditLog.Read.All",
    "SecurityEvents.Read.All",
    "User.Read.All",
    "User.ReadWrite.All",              // Disable/enable accounts
    "UserAuthenticationMethod.ReadWrite.All", // Revoke MFA
    "Directory.ReadWrite.All",         // Account state changes
  ],
};

// Graph API base
export const GRAPH_BASE = "https://graph.microsoft.com/v1.0";
export const GRAPH_BETA = "https://graph.microsoft.com/beta";

// IMA org config
export const ORG_CONFIG = {
  tenantId: "deb5b3ad-aea3-4155-9bdc-a24b07cb7dd4",
  domain: "theimagroup.com",
  auditEmail: "imait@theimagroup.com",
  sharepointSite: "imagroupmgmt.sharepoint.com",
  sharepointSiteName: "ITSec",
  sharepointListName: "PhishingResponseAudit",
  delegationMaxHours: 24,
  delegationDefaultHours: 6,
  // Restrict app access to this Entra ID group (set group object ID or leave null for all org users)
  allowedGroupId: null,
};
